// NOTE: if you add any filters that rely on model ids (for ex. product.segmentId, product.recommenderId, product.campaignId, etc.)
// don't forget to change domain-migration-helper in the API to replace source ids with destination ids in segment.rules[].filters[]!
const filters = {
  count: {
    name: 'Count',
    inputType: 'range',
    conditionType: 'count',
    min: 1,
    step: 1,
    placeholder: ['e.g. 1', 'e.g. 3'],
  },
  group: {
    name: 'Group',
    field: 'group',
    inputType: 'range',
    conditionType: 'floatRange',
    min: 0,
    step: 1,
    max: 9999,
    placeholder: ['starting from 0', 'up to and including 9999'],
  },
  campaignId: {
    name: 'After campaign / workflow interaction',
    field: 'campaignId',
    inputType: 'select',
    conditionType: 'term',
  },
  emailId: {
    name: 'After email interaction',
    field: 'emailId',
    inputType: 'select',
    conditionType: 'term',
  },
  pushNotificationId: {
    name: 'After push notification interaction',
    field: 'pushNotificationId',
    inputType: 'select',
    conditionType: 'term',
  },
  textMessageId: {
    name: 'After text message interaction',
    field: 'textMessageId',
    inputType: 'select',
    conditionType: 'term',
  },
  viberMessageId: {
    name: 'After viber message interaction',
    field: 'viberMessageId',
    inputType: 'select',
    conditionType: 'term',
  },
  // Values are recommender tokens. Domain cloning does NOT remap them yet (see the NOTE at the
  // top of this file, and the same gap on `pageToken` in behaviorRuleFilters) - until
  // domain-migration-helper in the API handles them, a cloned segment carrying this filter keeps
  // source-domain tokens and silently matches nothing.
  // Tracked in https://github.com/Releva-ai/magellan-api/pull/2763.
  productBlock: {
    name: 'After product block interaction',
    field: 'recommenderId',
    inputType: 'select',
    conditionType: 'term',
  },
  bannerBlock: {
    name: 'After banner block interaction',
    field: 'bannerBlockId',
    inputType: 'select',
    conditionType: 'term',
  },
  isFirstSesssion: {
    name: 'Is first session?',
    field: 'isFirstSession',
    inputType: 'checkbox',
    conditionType: 'term',
    values: [true],
  },
  whatsappMessageId: {
    name: 'After whatsapp message interaction',
    field: 'whatsappMessageId',
    inputType: 'select',
    conditionType: 'term',
  },
  consent: {
    name: 'Consent',
    field: 'consent',
    inputType: 'string',
    conditionType: 'term',
  },
  profileTags: {
    name: 'Tags',
    field: 'profile.tags',
    inputType: 'string',
    conditionType: 'term',
  },
};

export default filters;
